<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="350">
      <v-card>
        <v-card-title>
          <span class="text-h5">Input Kapal Baru</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Nama Kapal"
                  required
                  v-model="formData.nama_kapal"
                  autofocus
                  @keydown.enter="focusTglBerangkat"
                  ref="nama_kapal"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <label for="tgl_berangkat">Tanggal Berangkat</label>
                <input type="date" id="tgl_berangkat" v-model="formData.tgl_berangkat" @keydown.enter="focusRefs('voy1')" ref="tgl_berangkat">
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <div class="flex">
                  <v-text-field
                    label="NNN"
                    required
                    v-model="formData.voy1"
                    @keydown.enter="focusRefs('voy2')"
                    ref="voy1"
                  ></v-text-field>
                  <p class="separator">/</p>
                  <v-text-field
                    label="YY"
                    required
                    v-model="formData.voy2"
                    @keydown.enter="createData"
                    ref="voy2"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            :loading="loading"
            text
            tabindex="-1"
            @click="$emit('close-modal')"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            :loading="loading"
            text
            @click="createData"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "VesselModal",
  props: ["openModal"],
  data() {
    return {
      formData: {
        nama_kapal: '',
        tgl_berangkat: new Date().toISOString().slice(0,10),
        voy1: '',
        voy2: ''
      },
      loading: false,
    };
  },
  methods: {
    async createData() {
      this.loading = true;

      await axios.post(`vessel`, this.formData)
        .then(res => {
          this.loading = false;

          this.resetForm();
          this.$emit('close-modal', res.data);
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        }); 
    },
    focusTglBerangkat() {
      this.$refs.tgl_berangkat.focus();
    },
    focusRefs(ref) {
      this.$refs[ref].$refs.input.click();
    },
    resetForm() {
      this.formData = {
        nama_kapal: '',
        tgl_berangkat: '',
        voy1: '',
        voy2: ''
      };
    }
  },
};
</script>

<style scoped>

.flex {
  display: flex;
}

.separator {
  margin: auto;
  padding: 0 7px;
  font-weight: bold;
  font-size: 15px;
}

</style>